import { render, staticRenderFns } from "./RelatoriosCampanhasSegmentadas.vue?vue&type=template&id=6de37a46&scoped=true"
import script from "./RelatoriosCampanhasSegmentadas.vue?vue&type=script&lang=js"
export * from "./RelatoriosCampanhasSegmentadas.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosCampanhasSegmentadas.vue?vue&type=style&index=0&id=6de37a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de37a46",
  null
  
)

export default component.exports